
import { defineComponent } from "@vue/runtime-core";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import store from "../store/index";

import { mapActions, mapGetters, mapMutations } from "vuex";
import Button from "primevue/button";

export default defineComponent({
  name: "Login",
  components: {
    Form,
    Field,
    ErrorMessage,
    Button,
  },
  data() {
    const schema = yup.object().shape({
      username: yup.string().required("Введите логин!"),
      password: yup.string().required("Введите пароль!"),
    });

    return {
      isLoading: false,
      message: "",
      schema,
    };
  },
  computed: {
    ...mapGetters("auth", {
      getterLoginStatus: "getLoginStatus",
    }),
  },
  methods: {
    ...mapActions("auth", {
      actionLogin: "login",
    }),
    async login(user: any) {
      this.isLoading = true;
      await this.actionLogin(user);
      if (this.getterLoginStatus === "success") {
        this.$router.push("/orders");
      } else {
        this.isLoading = false;
        this.message = "Логин или пароль неверны!";
      }
    },
  },
});
